module.exports = __webpack_public_path__ + "static/img/Rod-Wishart.f9dce82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rod-Wishart.jpg
// module id = RzI0
// module chunks = 0